import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckBoxListProps } from './types';

const CheckBoxList = ({ items, selected, setSelected }: CheckBoxListProps) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    const updatedSelected = checked
      ? [...selected, id]
      : selected.filter((itemId) => itemId !== id);

    setSelected(updatedSelected);
  };

  return (
    <>
      {items.map((item) => (
        <FormControlLabel
          key={item.id}
          control={
            <Checkbox
              id={item.id}
              name={item.name}
              checked={selected.includes(item.id)}
              onChange={handleCheckboxChange}
            />
          }
          label={item.name}
        />
      ))}
    </>
  );
};

export default CheckBoxList;
